import { render, staticRenderFns } from "./returnSuccess.vue?vue&type=template&id=3b9e52ba&scoped=true&"
import script from "./returnSuccess.vue?vue&type=script&lang=ts&"
export * from "./returnSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./returnSuccess.vue?vue&type=style&index=0&id=3b9e52ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b9e52ba",
  null
  
)

export default component.exports